<div *ngIf="isOpened && !modal" #popup class="window" [style.minWidth]="minWidth" [style.width]="width" [style.minHeight]="minHeight" [style.height]="height" [style.top]="top" [style.left]="left" [style.right]="right" [style.opacity]="!isInitialized ? '0' : '1'">
    <div class="title-bar" [class.cursor-move]="isDraggable && !isMaximized" (mousedown)="onDrag($event)">
        <div class="title" [class.cursor-move]="isDraggable && !isMaximized">
            {{ windowTitle }}
        </div>
        <div class="actions">
            <slot name="actions"></slot>
            <button class="action-icon" title="Maximize" (click)="onMaximize()" *ngIf="isMaximizable && !isMaximized">
                <span class="action-icon-maximize"></span>
            </button>
            <button class="action-icon" title="Restore" (click)="onRestore()" *ngIf="isMaximizable && isMaximized">
                <span class="action-icon-restore"></span>
            </button>
            <button class="action-icon" title="Close" (click)="close()">
                <span class="action-icon-close"></span>
            </button>
        </div>
    </div>
    <div class="content">
        <slot name="content"></slot>
    </div>
    <ng-container *ngIf="isResizable && !isMaximized">
        <div #resizeTop id="resizeTop" class="resize-handle resize-handle-top" (mousedown)="onResize($event, resizeTop)"></div>
        <div #resizeTopRight id="resizeTopRight" class="resize-handle resize-handle-diagonal resize-handle-top-right" (mousedown)="onResize($event, resizeTopRight)"></div>
        <div #resizeRight id="resizeRight" class="resize-handle resize-handle-right" (mousedown)="onResize($event, resizeRight)"></div>
        <div #resizeBottomRight id="resizeBottomRight" class="resize-handle resize-handle-diagonal resize-handle-bottom-right" (mousedown)="onResize($event, resizeBottomRight)"></div>
        <div #resizeBottom id="resizeBottom" class="resize-handle resize-handle-bottom" (mousedown)="onResize($event, resizeBottom)"></div>
        <div #resizeBottomLeft id="resizeBottomLeft" class="resize-handle resize-handle-diagonal resize-handle-bottom-left" (mousedown)="onResize($event, resizeBottomLeft)"></div>
        <div #resizeLeft id="resizeLeft" class="resize-handle resize-handle-left" (mousedown)="onResize($event, resizeLeft)"></div>
        <div #resizeTopLeft id="resizeTopLeft" class="resize-handle resize-handle-diagonal resize-handle-top-left" (mousedown)="onResize($event, resizeTopLeft)"></div>
    </ng-container>
</div>

<div *ngIf="isOpened && modal" class="modal" [style.display]="!isInitialized ? 'none' : ''">
    <div class="overlay"></div>
    <div #modal class="window" [style.minWidth]="minWidth" [style.width]="width" [style.height]="height">
        <div class="title-bar">
            <div class="title">
                {{ windowTitle }}
            </div>
            <div class="actions">
                <slot name="actions"></slot>
                <button class="action-icon" title="Close" (click)="close()" *ngIf="closable">
                    <span class="action-icon-close"></span>
                </button>
            </div>
        </div>
        <div class="content">
            <slot name="content"></slot>
        </div>
    </div>
</div>
